import { Download, Eye, ImageOff, Images } from 'lucide-react';
import { getImageUrl } from '../utils/helpers';

export default function PhotoAlbum({
  title,
  photos = [],
  icon: Icon = Images,
  branding,
  onDownloadPhoto,
  onPreviewPhoto,
  downloadingKey,
}) {
  const getPhotoPath = (photo) => {
    if (!photo) return '';
    return typeof photo === 'string' ? photo : photo.path;
  };

  const getPhotoKey = (photo, index) => {
    return `${branding?.id || 'branding'}-${photo?.id || index}`;
  };

  if (!photos || photos.length === 0) {
    return (
      <section className="photo-album-card">
        <div className="photo-album-header">
          <div className="photo-album-title">
            <span className="photo-album-icon">
              <Icon size={18} />
            </span>
            <div>
              <h3>{title}</h3>
              <p>0 photo</p>
            </div>
          </div>
        </div>

        <div className="empty-photo-album">
          <ImageOff size={34} />
          <span>Aucune photo</span>
        </div>
      </section>
    );
  }

  return (
    <section className="photo-album-card">
      <div className="photo-album-header">
        <div className="photo-album-title">
          <span className="photo-album-icon">
            <Icon size={18} />
          </span>

          <div>
            <h3>{title}</h3>
            <p>
              {photos.length} {photos.length > 1 ? 'photos' : 'photo'}
            </p>
          </div>
        </div>

        <span className="photo-count-badge">{photos.length}</span>
      </div>

      <div className="photo-grid">
        {photos.map((photo, index) => {
          const photoPath = getPhotoPath(photo);
          const normalizedPhoto =
            typeof photo === 'string'
              ? {
                  path: photo,
                  typeLabel: title,
                }
              : photo;

          const key = getPhotoKey(normalizedPhoto, index);
          const isDownloading = downloadingKey === key;

          return (
            <div
              key={normalizedPhoto?.id || `${photoPath}-${index}`}
              className="photo-tile"
              role="button"
              tabIndex={0}
              onClick={() =>
                onPreviewPhoto({
                  title,
                  photo: normalizedPhoto,
                  branding,
                  index,
                })
              }
              onKeyDown={(event) => {
                if (event.key === 'Enter') {
                  onPreviewPhoto({
                    title,
                    photo: normalizedPhoto,
                    branding,
                    index,
                  });
                }
              }}
            >
              <img src={getImageUrl(photoPath)} alt={`${title} ${index + 1}`} />

              <div className="photo-gradient" />

              <span className="photo-index">{index + 1}</span>

              <div className="photo-hover-label">
                <Eye size={16} />
                Voir
              </div>

              <button
                type="button"
                className="photo-download-button"
                onClick={(event) => {
                  event.stopPropagation();
                  onDownloadPhoto(normalizedPhoto, branding, index);
                }}
                disabled={isDownloading}
                title="Télécharger cette photo"
              >
                {isDownloading ? <span className="tiny-loader" /> : <Download size={16} />}
              </button>
            </div>
          );
        })}
      </div>
    </section>
  );
}